// Card primitive — bordered container matching travel.imorbis.com aesthetic.

import { ReactNode } from 'react';
import { T } from '../theme';

export function Card({ children, padding = 28 }: { children: ReactNode; padding?: number }) {
  return <div style={{ ...cardStyles.card, padding }}>{children}</div>;
}

export function CardLabel({ children }: { children: ReactNode }) {
  return <div style={cardStyles.label}>{children}</div>;
}

export function CardTitle({ children }: { children: ReactNode }) {
  return <div style={cardStyles.title}>{children}</div>;
}

export function CardSub({ children }: { children: ReactNode }) {
  return <div style={cardStyles.sub}>{children}</div>;
}

export function StatBlock({ label, value, sub }: { label: string; value: string; sub?: string }) {
  return (
    <div style={cardStyles.stat}>
      <div style={cardStyles.statValue}>{value}</div>
      <div style={cardStyles.statLabel}>{label}</div>
      {sub && <div style={cardStyles.statSub}>{sub}</div>}
    </div>
  );
}

const cardStyles: Record<string, React.CSSProperties> = {
  card: {
    border: `1px solid ${T.rule}`,
    background: 'transparent',
    transition: 'border-color 0.3s',
  },
  label: {
    fontFamily: T.font.mono,
    fontStyle: 'normal',
    fontSize: 11,
    letterSpacing: '0.06em',
    textTransform: 'uppercase' as const,
    color: T.inkSoft,
    marginBottom: 12,
  },
  title: {
    fontFamily: T.font.display,
    fontWeight: 600,
    fontSize: 20,
    color: T.ink,
    letterSpacing: '-0.02em',
    marginBottom: 8,
  },
  sub: {
    fontFamily: T.font.body,
    fontStyle: 'normal',
    fontSize: 14,
    color: T.inkMute,
    marginBottom: 14,
  },
  stat: {
    border: `1px solid ${T.rule}`,
    padding: '24px 20px',
    textAlign: 'center' as const,
  },
  statValue: {
    fontFamily: T.font.display,
    fontSize: 30,
    color: T.accent,
    letterSpacing: '0.02em',
    marginBottom: 8,
  },
  statLabel: {
    fontSize: 11,
    letterSpacing: '0.18em',
    textTransform: 'uppercase' as const,
    color: T.inkSoft,
  },
  statSub: {
    fontSize: 11,
    color: T.inkMute,
    marginTop: 6,
    fontFamily: T.font.mono,
    fontStyle: 'normal',
  },
};
